//
// 徽章
// ============================================================
import Ns from "./utility";

const Badge = () => new Ns({
    el: ".button[data-badge-maxValue]",
    load() {
        Ns.each(ns(this).get(), item => {
            let maxValue = ns(item).attr("data-badge-maxValue");
            if(ns(item).text() >= maxValue) {
                ns(item).text(maxValue + "+");
            }
        })
    },
});

module.exports = Badge;


// WEBPACK FOOTER //
// src/js/badge.js